import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CACHE_TIME, STALE_TIME } from "../ApiProvider";
import { api } from "./api";
// Query keys for team venue operations
const USE_LIST_TEAM_HOME_VENUES = "useListTeamHomeVenues";
// Team venue listing hook (unchanged - still uses team endpoint)
export const useListTeamHomeVenues = ({ teamId, enabled = true, }) => {
    return useQuery({
        queryKey: [USE_LIST_TEAM_HOME_VENUES, teamId],
        queryFn: async () => {
            const { data } = await api.get(`/teams/${teamId}/venues/`);
            return data;
        },
        enabled: !!teamId && enabled,
        staleTime: STALE_TIME,
        cacheTime: CACHE_TIME,
    });
};
export const useAddVenueToTeam = ({ onSuccess, onError, teamId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (data) => {
            return api.post(`/team-venues/`, data);
        },
        onSuccess: (data) => {
            // Use the teamId passed as parameter
            if (teamId) {
                queryClient.invalidateQueries([USE_LIST_TEAM_HOME_VENUES, teamId]);
            }
            onSuccess(data);
        },
        onError,
    });
};
// Deactivate venue hook (new)
export const useDeactivateVenueFromTeam = ({ onSuccess, onError, teamId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async ({ teamVenueId, ...data }) => {
            return api.post(`/team-venues/${teamVenueId}/deactivate/`, data);
        },
        onSuccess: (data) => {
            // Use the teamId passed as parameter
            if (teamId) {
                queryClient.invalidateQueries([USE_LIST_TEAM_HOME_VENUES, teamId]);
            }
            onSuccess(data);
        },
        onError,
    });
};
export const useRemoveVenueFromTeam = ({ onSuccess, onError, teamId, }) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (teamVenueId) => {
            return api.delete(`/team-venues/${teamVenueId}/`);
        },
        onSuccess: () => {
            // Since we don't have team info from delete response, invalidate all
            queryClient.invalidateQueries([USE_LIST_TEAM_HOME_VENUES, teamId]);
            onSuccess();
        },
        onError,
    });
};
